import { lazy } from 'react';

export const TariffPageLazy = lazy(() => import('./TariffPage'));
